import { QUERY_KEYS } from '@/queries/queryKeys'
import { premiumService } from '@/services/api/premium/premium.service'
import { useQuery } from '@tanstack/react-query'

type useGetSelfServiceInfoProps = {
  enabled?: boolean
}

export const useGetSelfServiceInfo = ({ enabled }: useGetSelfServiceInfoProps = {}) => {
  return useQuery({
    queryKey: [QUERY_KEYS.premium.getSelfServiceInfo],
    queryFn: async () => {
      const response = await premiumService.getSelfServiceInfo()
      return response.data
    },
    enabled,
  })
}
